import * as t from './actionTypes';
import { UserPreferencesState, Action } from './types';

export const USER_PREFERENCES_STATUS = {
  ERROR: 'Error',
  FETCHING: 'Fetching',
  SUCCESS: 'Success',
  UPDATING: 'Updating',
};

export const MODALS = {
  DISABLE_MFA_MODAL: 'preferences/disable-mfa-modal',
};

export const initialState: UserPreferencesState = {
  currentModal: '',
  details: {
    avatarUrl: '',
    firstName: '',
    key: '',
    lastName: '',
    mfaIsEnabled: false,
    qrCodeUrl: '',
    scratchCodes: [],
  },
  errors: [],
  status: '',
};

export const userPreferencesReducer = (
  state = initialState,
  action: Action = {},
): UserPreferencesState => {
  switch (action.type) {
    case t.USER_PREFERENCES_ERRORS_RESPONSE: {
      return {
        ...state,
        errors: action.errors,
        status: USER_PREFERENCES_STATUS.ERROR,
      };
    }

    case t.DISABLE_TWO_FACTOR_AUTH_REQUEST:
    case t.ENABLE_TWO_FACTOR_AUTH_REQUEST:
    case t.FETCH_USER_PREFERENCES_REQUEST: {
      return {
        ...state,
        errors: [],
        status: USER_PREFERENCES_STATUS.FETCHING,
      };
    }

    case t.FETCH_USER_PREFERENCES_RESPONSE: {
      return {
        ...state,
        details: { ...state.details, ...action.payload },
        errors: [],
        status: USER_PREFERENCES_STATUS.SUCCESS,
      };
    }

    default: {
      return state;
    }
  }
};
